import { useState } from 'react';

export enum requestStatuses {
    idle = 'IDLE',
    loading = 'LOADING',
    success = 'SUCCESS',
    fail = 'FAIL'
}

interface keyValuePairs {
    [key: string]: string
}

interface returnType {
    netlifySubmit: (formName: string, fields: keyValuePairs)=> void,
    requestStatus: requestStatuses
}

const useNetlifyFormRequest = (): returnType => {
    const [requestStatus, setRequestStatus] = useState<requestStatuses>(requestStatuses.idle);

    const encode = (data: keyValuePairs) => {
        return Object.keys(data)
            .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
            .join('&');
    };

    const netlifySubmit = (formName: string, fields: keyValuePairs): void => {
        setRequestStatus(requestStatuses.loading);

        fetch('/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: encode({ 'form-name': formName, ...fields })
        }).then((response) => {
            if (response.ok) {
                setRequestStatus(requestStatuses.success);
                return;
            }

            setRequestStatus(requestStatuses.fail);
        }).catch(() => {
            setRequestStatus(requestStatuses.fail);
        });
    };

    return {
        netlifySubmit,
        requestStatus
    };
};

export default useNetlifyFormRequest;
